// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_JUl","cls2":"Filter-cls2_WIj Filter-cls1_JUl","isSelected":"Filter-isSelected_d9H","isDisabled":"Filter-isDisabled_BZL"};